import React from 'react';
import moment from "moment"
import * as echarts from 'echarts/lib/echarts';

let myChart = null;
class Ocharts extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  render() {
    return (
      <div id='ocharts' >

      </div>
    )
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    myChart = !myChart ? echarts.init(document.getElementById('ocharts')) : myChart;
    var day = []
    var value = []
    nextProps.consumptionData.data.map((item) => {
      day.push(moment(item.createTime).format("MM-DD HH:mm"))
      value.push((item.value * 1).toFixed(2))
    })
    let newday = day.filter((x, index, self) => self.indexOf(x) === index)
    let option = {
      backgroundColor: '#fff',
      color: ['#73A0FA', '#73DEB3', '#FFB761'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          crossStyle: {
            color: '#999'
          },
          lineStyle: {
            type: 'dashed'
          }
        }
      },
      grid: {
        left: '25',
        right: '25',
        bottom: '44',
        top: '85',
        containLabel: true
      },
      legend: {
        // data: ['进水', '出水'],
        orient: 'horizontal',
        icon: "rect",
        show: true,
        left: 20,
        top: 5,
      },
      xAxis: {
        type: 'category',
        data: newday,
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
      },
      dataZoom: [{
        type: 'inside',
        start: 0,
        end: 100
      }, {
        start: 0,
        end: 100
      }],
      yAxis: {
        type: 'value',
        // max: max_value>=100? max_value + 100: max_value+10,
        // max: max_value > 100 ? max_value * 2 : max_value + 10,
        // interval: 10,
        // nameLocation: "center",
        axisLabel: {
          color: '#999',
          fontSize: 12,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: '#F3F4F4'
          }
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        },
        // name: '吨'
      },
      series: [{
        name: nextProps.consumptionData.label,
        type: 'line',
        smooth: true,
        data: value
      }]
    };

    myChart.setOption(option);
    window.addEventListener("resize", this.resizeFn);
  }

  resizeFn() {
		myChart.resize();
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.resizeFn);
		myChart = null;
	}

}

export default Ocharts
